Popups = {};

(function (p, $) {
	"use strict";

	/**
	 * Public API
	 ****************************************************/

	p.hideAll = function () {
		this.Multichoice.hide();
		this.DatePicker.hide();
		this.HourPicker.hide();
	};

	/**
	 * Multichoice
	 ****************************************************/

	p.Multichoice = {
		_elem:null,
		_list:null,
		_opened:false,
        _hideCallback:null,
		show:function (elem, list, options, callback, other_info, evt, hideCallback) {
            if(!other_info){
                other_info = [];
            }

			$('#popups-multichoice').css('top', '0px').css('left', '0px').empty();

            this._hideCallback = null;
			this._elem = elem;
			this._list = list;
            var tbl = $('<table><tr><td class="menu_header"></td></tr><tr><td class="menu_body"></td></tr><tr><td class="menu_footer"></td></tr></table>');

			// Add list
			var listItem;
			var listLen = list.length;
			var listCt = $('<ul style="position: relative; /*width: 100%;*/ margin: -3px 0; z-index: 0; display: block;" class="multichoice dropdown-menu rounded_border"></ul>');
			var item;
            debug.log('Popup show:', list);
			for (var i = 0; i < listLen; i++) {
				listItem = list[i];

				item = $('<li title="' + listItem.tooltip + '" class="" data-id="' + listItem.data + '"></li>');

                if(options.editable){
                    $(item).append('<a style="text-wrap: normal;" tabindex="-1"><input type="checkbox" style="margin-right: 8px;"' +(listItem.isChecked?'checked="checked"':'')+ '><span>' + listItem.label + '</span></a>');
                } else {
                    $(item).append('<a style="text-wrap: normal;" tabindex="-1"><span>' + listItem.label + '</span></a>');
                }

                if(listItem.disabled){
                    $(item).addClass('inactive');
                } else {

                    if(options.editable){
                        $(item).find('a span').click(function(){
                            var cb = $(this).parent().find('input');
                            if($(cb).is(':checked')){
                                $(cb).removeAttr('checked');
                            } else {
                                $(cb).attr('checked', 'checked');
                            }

                            $(cb).trigger('change');
                        });

                        $(item).find('input[type=checkbox]').change(function(){
                            var list = Popups.Multichoice._list;
                            var _item = null;
                            var currData = $(this).closest('li').attr('data-id');

                            for (var i = 0; i < list.length; i++) {
                                item = list[i];

                                if (item.data == currData) {
                                    _item = item;
                                }
                            }

                            _item.isChecked = $(this).is(':checked');

                            callback(_item);
                        });
                    } else {
                        $(item).click(function () {
                            var list = Popups.Multichoice._list;
                            var _item = null;
                            var currData = $(this).attr('data-id');

                            for (var i = 0; i < list.length; i++) {
                                item = list[i];

                                if (item.data == currData) {
                                    _item = item;
                                }
                            }

                            $(Popups.Multichoice._elem).removeClass('active');

                            callback(_item);
                            Popups.hideAll();
                        });
                    }
                }

				$(item).appendTo($(listCt));
			}

            if(other_info){
                var _otherInfoCounter = 0;
                for(var z = 0; z < other_info.length; z++){
                    if(other_info[z].label){
                        if(_otherInfoCounter == 0){
                            $('<li class="meta_info"><div style="width: 100%; margin: auto; height: 1px; border-top: solid 1px #CCC;"></div></li>').appendTo($(listCt));
                        }

                        $('<li title="' + other_info[z].tooltip + '" class="meta_info" data-id="' + other_info[z].data + '" style=""><a class="meta_info" style="text-wrap: normal;" tabindex="-1"><span style="font-weight: bold;">'+other_info[z].title+':&nbsp;</span><span style="font-style: italic;">'+other_info[z].label+'</span></a></li>').appendTo($(listCt));
                        _otherInfoCounter++;
                    }
                }
            }

            var
                _asize = parseInt($(window).height() - $(elem).position().top + $(elem).height()),
                _msize = parseInt((listLen + other_info.length + 1)*30) + 30,
                arrow;


            if(_asize < _msize){
                arrow = $('<img src="/assets/multichoice_arrow_down.png" style="position: relative; height: 15px; z-index: 1;" class="">');
            } else {
                arrow = $('<img src="/assets/multichoice_arrow.png" style="position: relative; height: 15px; z-index: 1;" class="">');
            }

			if (options.align == 'right') {
				$(arrow).addClass('float_right').css('margin-right', ((Math.max($(elem).width(), 20) - 19) / 2) + 'px');
                $(listCt).addClass('float_right');
                $('#popups-multichoice').addClass('float_right');
			} else {
				$(arrow).addClass('float_left').css('margin-left', ((Math.max($(elem).width(), 20) - 19) / 2) + 'px');
                $(listCt).addClass('float_left');
                $('#popups-multichoice').addClass('float_left');
			}

            /*
            if(_asize < _msize){
                //$(listCt).appendTo('#popups-multichoice');
                //$(arrow).appendTo('#popups-multichoice');

                $(arrow).appendTo($(tbl).find('td.menu_footer'));
            } else {
                //$(arrow).appendTo('#popups-multichoice');
                //$(listCt).appendTo('#popups-multichoice');

                $(arrow).appendTo($(tbl).find('td.menu_header'));
            }
            */

            $(listCt).appendTo($(tbl).find('td.menu_body'));
            $(tbl).appendTo('#popups-multichoice');

			// Hide other popups
			Popups.hideAll();

			// Show
			$(this._elem).addClass('active');
			$('#popups').show();
			$('#popups-multichoice').fadeIn();

            // adjust multichoice width
            /*
            var xx = $('#popups-multichoice span'), xmin = 300;
            for(var x = 0; x < xx.length; x++){
                if(($(xx[x]).textWidth() + 10) < xmin){
                    xmin = $(xx[x]).textWidth() + 10;
                }
            }

            $('#popups-multichoice').css('width', xmin);
            */

            // Center multichoice
            if(_asize < _msize){
                /*
                $('#popups-multichoice').css('top', parseInt($(elem).position().top) - parseInt($('#popups-multichoice').height()));
                $('#popups-multichoice').css('left', parseInt($(elem).position().left + $(elem).width()) - parseInt($(tbl).width()));
                */
                $('#popups-multichoice').position({
                    my:options.align + ' bottom',
                    at:options.align + ' top',
                    of:$(elem)
                });
            } else {
                $('#popups-multichoice').position({
                    my:options.align + ' top',
                    at:options.align + ' bottom',
                    of:$(elem)
                });
            }

            this._hideCallback = hideCallback;
			this._opened = true;
			return this;
		},
		hide:function () {
			$('#popups').hide();
			$('#popups-multichoice').hide();

			$(this._elem).removeClass('active');

			this._opened = false;

            try {
                if(this._hideCallback != undefined && this._hideCallback != null){
                    this._hideCallback();
                }
            } catch(ex) {
                //debug.log('MultiChoiceHide', ex);
            }

			return this;
		}
	};

	/**
	 * DatePicker
	 ****************************************************/

	p.DatePicker = {
		_elem:null,
		_opened:false,
		show:function (elem, options) {
			$('#popups-datepicker').css('top', '0px').css('left', '0px').empty();

			this._elem = elem;

			var ct = $('<div style="position: relative; margin-top: 4px; width: 200px; height: 200px; z-index: 0; display: block; background-color: red;" class="drop_shadow rounded_border"></div>');
			$(ct).appendTo('#popups-datepicker');

			// Hide other popups
			Popups.hideAll();

			// Center multichoice
			$('#popups-datepicker').position({
				my:'left top',
				at:'left bottom',
				of:$(elem)
			});

			// Show
			$('#popups').show();
			$('#popups-datepicker').fadeIn();

			this._opened = true;
			return this;
		},
		hide:function () {
			$('#popups').hide();
			$('#popups-datepicker').hide();

			this._opened = false;
			return this;
		}
	};

	/**
	 * HourPicker
	 ****************************************************/

	p.HourPicker = {
		_elem:null,
		_targetElem:null,
		_opened:false,
		show:function (elem, target, options) {
            if($(elem).is(':disabled') || $(elem).attr('disabled') == 'disabled'){
                return false;
            }

            $('#popups-hourpicker').css('top', '0px').css('left', '0px').empty();

			this._elem = elem;
			this._targetElem = $(target);

            $(elem).css('cursor', 'pointer');

			var hourText = $(target).val().split(':')[0];
			var minutesText = $(target).val().split(':')[1];
			var currDate = new Date();

			if (hourText == null || hourText == '') {
				hourText = parseInt(currDate.getHours());
				hourText = hourText < 10 ? ("0" + hourText) : hourText;
			}

			if (minutesText == null) {
				minutesText = parseInt(currDate.getMinutes());
				minutesText = minutesText < 9 ? ("0" + minutesText) : minutesText;
			}

			var ct = $('<form onsubmit="Popups.HourPicker.save(); return false;" style="float: left; padding: 4px; width: 131px; overflow: hidden; z-index: 0; display: block; background-color: white; border: solid 1px #A9D9E0;" class="hour_picker rounded_border drop_shadow"></form>');

			var hoursCt = $('<div id="hour-picker-hour-ct" class="float_left hour_ct"><div class="plus_btn"></div><input type="text" id="hour-picker-hour-text" class="hour_text" value="' + hourText + '"/><div class="minus_btn"></div></div>');
			var minutesCt = $('<div id="hour-picker-minute-ct" class="float_left minutes_ct" style="margin-left: 3px;"><div class="plus_btn"></div><input type="text" id="hour-picker-minute-text" class="minutes_text" value="' + minutesText + '" /><div class="minus_btn"></div></div>');
			var buttonsCt = $('<div class="float_left" style="margin-left: 3px; width: 25px;"><button type="submit" class="pop_ok_btn"></button><button type="button" class="pop_cancel_btn"></button></div>');

			$(hoursCt).appendTo($(ct));
			$(minutesCt).appendTo($(ct));
			$(buttonsCt).appendTo($(ct));

			$(ct).appendTo('#popups-hourpicker');

			// Hide other popups
			Popups.hideAll();

			// Show
			$('#popups').show();
			$('#popups-hourpicker').fadeIn();

            // Center multichoice
            $('#popups-hourpicker').position({
                my:'left top',
                at:'left bottom',
                of:$(elem)
            });

			// Add events
			$(elem).blur(function (event) {
				//Popups.HourPicker.save();
			});

			$(elem).keyup(function (event) {
				var val = $(this).val().trim();
				var hourPattern = /[0-9][0-9]/g;

				if (event.keyCode != 46 && event.keyCode != 8) {
					if (val.length == 2 && hourPattern.test(val)) {
						val += ":";
						$(this).val(val);
					} else if (val.length == 1 && parseInt(val) > 2) {
						val = "0" + val;
						$(this).val(val);
					}
				}

				if (val.match(/(\d+)(?::(\d+))?/)) {
					var currHour = val.split(':')[0];
					var currMinute = val.split(':')[1];
					$('.hour_picker .hour_text').attr('data-hour', currHour).val(currHour);
					$('.hour_picker .minutes_text').attr('data-minute', currMinute).val(currMinute);
				}
			});

            $(elem).keydown(function (e) {
                if(e.which == 13){
                    Rails.fire($('form.hour_picker')[0], 'submit');
                }
            });

            $('.hour_picker .minutes_ct .minutes_text').keydown(function (e) {
                if(e.which == 38){
                    Popups.HourPicker.updateMinutes(true);
                } else if(e.which == 40){
                    Popups.HourPicker.updateMinutes(false);
                }
            });

            $('.hour_picker .hour_ct .hour_text').change(function () {
                if(parseInt($(this).val()) != NaN && (parseInt($(this).val()) <= 23 && parseInt($(this).val()) >= 0)){
                    $(this).attr('data-hour', parseInt($(this).val()));
                }
            });

            $('.hour_picker .minutes_ct .minutes_text').change(function () {
                if(parseInt($(this).val()) != NaN && (parseInt($(this).val()) <= 59 && parseInt($(this).val()) >= 0)){
                    $(this).attr('data-minute', parseInt($(this).val()));
                }
            });

			$('.hour_picker .hour_ct .plus_btn').click(function () {
				Popups.HourPicker.updateHours(true);
			});

			$('.hour_picker .hour_ct .minus_btn').click(function () {
				Popups.HourPicker.updateHours(false);
			});

			$('.hour_picker .minutes_ct .plus_btn').click(function () {
				Popups.HourPicker.updateMinutes(true);
			});

			$('.hour_picker .minutes_ct .minus_btn').click(function () {
				Popups.HourPicker.updateMinutes(false);
			});

            /*
			$('.hour_picker .pop_ok_btn').click(function () {
				Popups.HourPicker.save();
			});
            */

			$('.hour_picker .pop_cancel_btn').click(function () {
				Popups.HourPicker.hide();
			});

			if (window.addEventListener) {
				window.addEventListener('DOMMouseScroll', Popups.HourPicker.wheel, false);
			}

            window.onmousewheel = Popups.HourPicker.wheel;

            //document.onmousewheel = Popups.HourPicker.wheel;


			if (hourText.length > 1 && hourText.charAt(0) == '0') {
				hourText = hourText.substr(1, 1);
			}

			if (minutesText.length > 1 && minutesText.charAt(0) == '0') {
				minutesText = minutesText.substr(1, 1);
			}

			$('.hour_picker .hour_text').attr('data-hour', hourText);
			$('.hour_picker .minutes_text').attr('data-minute', minutesText);

            //$('.hour_picker .hour_text').focus();

			this._opened = true;
			return this;
		},
		hide:function () {
			$('#popups').hide();
			$('#popups-hourpicker').hide();

			this._opened = false;

            window.onmousewheel = Hades._original_onmousewheel;

			return this;
		},
		updateHours:function (increment) {
			var currHour = parseInt($('.hour_picker .hour_text').attr('data-hour'));

			if (isNaN(currHour)) {
				currHour = 0;
			} else {
				currHour = increment ? currHour + 1 : currHour - 1;
			}

			if (currHour > 23) {
				currHour = 0;
			} else if (currHour < 0) {
				currHour = 23;
			}

			$('.hour_picker .hour_text').attr('data-hour', currHour).val(currHour < 10 ? "0" + currHour : currHour);
		},
		updateMinutes:function (increment) {
			var currMinute = parseInt($('.hour_picker .minutes_text').attr('data-minute'));

			if (isNaN(currMinute)) {
				currMinute = 0;
			} else {
				currMinute = increment ? currMinute + 1 : currMinute - 1;
			}

			if (currMinute > 59) {
				currMinute = 0;
			} else if (currMinute < 0) {
				currMinute = 59;
			}

			$('.hour_picker .minutes_text').attr('data-minute', currMinute).val(currMinute < 10 ? "0" + currMinute : currMinute);
		},
		wheel:function (event) {
            event.preventDefault();

			if (event.target.id === "undefined" && event.target.parentElement.id === undefined) {
				return;
			}

			var delta = 0;
			if (!event) event = window.event;
			if (event.wheelDelta) {
				delta = event.wheelDelta / 120;
			} else if (event.detail) {
				delta = -event.detail / 3;
			}

			if (delta) {
				/* Hours */
				if (event.target.id !== "undefined" && event.target.id == 'hour-picker-hour-text') {
					Popups.HourPicker.updateHours(delta > 0);
				} else if (event.target.parentElement !== undefined && event.target.parentElement != null) {
					if (event.target.parentElement.id !== undefined && (event.target.parentElement.id == 'hour-picker-hour-ct' || event.target.parentElement.id == 'hour-picker-hour-text')) {
						Popups.HourPicker.updateHours(delta > 0);
					}
				}

				/* Minutes */
				if (event.target.id !== "undefined" && event.target.id == 'hour-picker-minute-text') {
					Popups.HourPicker.updateMinutes(delta > 0);
				} else if (event.target.parentElement !== undefined && event.target.parentElement != null) {
					if (event.target.parentElement.id !== undefined && (event.target.parentElement.id == 'hour-picker-minute-ct' || event.target.parentElement.id == 'hour-picker-minute-text')) {
						Popups.HourPicker.updateMinutes(delta > 0);
					}
				}
			}
		},
		save:function () {
			var currHour = parseInt($('.hour_picker .hour_text').attr('data-hour'));
			var currMinute = parseInt($('.hour_picker .minutes_text').attr('data-minute'));

            if (currHour != parseInt($('.hour_picker .hour_text').val()) || currMinute != parseInt($('.hour_picker .minutes_text').val())) {
                Popups.HourPicker.hide();
                return false;
            }

			if (isNaN(currHour) || isNaN(currMinute)) {
				Popups.HourPicker.hide();
				return false;
			}

			$(Popups.HourPicker._targetElem).val((currHour < 10 ? "0" + currHour : currHour) + ":" + (currMinute < 10 ? "0" + currMinute : currMinute));
            $(Popups.HourPicker._targetElem).trigger('change');
			Popups.HourPicker.hide();
		}
	};

	/**
	 * Private Functions
	 ****************************************************/

	/**
	 *
	 */
	function checkClick(e) {
		if ($(e.target).attr('id') == 'popups') {
			$('#popups').hide();
			Popups.hideAll();
		}
	}

	/**
	 * On load
	 ****************************************************/

		// Add popups layer to body
	$(document).ready(function () {
		if ($('#popups').length == 0) {
			$('<div id="popups"></div>')
				.append('<div id="popups-multichoice" class="bootstrap open rounded_border"></div>')
				.append('<div id="popups-datepicker"></div>')
				.append('<div id="popups-hourpicker"></div>')
				.appendTo('body');

			$('#popups').click(function (e) {
				checkClick(e);
			});
		}
	});

}(Popups, jQuery));